import { EditableTableColumnType } from '@app/ui';
import { NotificationSetting } from '@app/notifications/api';
import { Checkbox, Form } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

export function useNotificationSettingsColumns(
  selectAll: { email: boolean; internal: boolean },
  handleSelectAll: (column: 'email' | 'internal') => (e: CheckboxChangeEvent) => void,
) {
  const { t } = useTranslation();

  return useMemo<EditableTableColumnType<NotificationSetting>[]>(() => {
    const columns: Array<EditableTableColumnType<NotificationSetting> | false> = [
      {
        title: t('notifications.settings.description'),
        dataIndex: 'type',
        key: 'type',
        render: (_, { type }) => t(`notifications.${type}.description`),
      },
      {
        title: (
          <Checkbox checked={selectAll.internal} onChange={handleSelectAll('internal')}>
            {t('notifications.settings.internal')}
          </Checkbox>
        ),
        dataIndex: 'internal',
        key: 'internal',
        render: (_, { type, internal }) => (
          <Form.Item name={`internal_${type}`} valuePropName="checked" initialValue={internal}>
            <Checkbox />
          </Form.Item>
        ),
      },
      {
        title: (
          <Checkbox checked={selectAll.email} onChange={handleSelectAll('email')}>
            {t('notifications.settings.email')}
          </Checkbox>
        ),
        dataIndex: 'email',
        key: 'email',
        render: (_, { type, email }) => (
          <Form.Item name={`email_${type}`} valuePropName="checked" initialValue={email}>
            <Checkbox />
          </Form.Item>
        ),
      },
    ];

    return columns.filter((x) => !!x) as EditableTableColumnType<NotificationSetting>[];
  }, [t, selectAll, handleSelectAll]);
}
